/* unplugin-vue-components disabled */import script from "./ProjectActive.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectActive.vue?vue&type=script&setup=true&lang=js"

import "./ProjectActive.vue?vue&type=style&index=0&id=9a6201a6&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a6201a6"]])

export default __exports__